import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatInputModule} from '@angular/material/input';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatStepperModule} from '@angular/material/stepper';
import {TranslateModule} from '@ngx-translate/core';

import {ContentLoaderComponent, DialogCloseButtonComponent} from '@q9elements/ui-kit/components';
import {SharedModule} from '../../../../../../shared/shared.module';
import {CustomViewService} from '../../../../../services/custom-view.service';
import {CustomViewModalViewsModule} from '../../../custom-view-model-views.module';
import {CreateNewViewDialogComponent} from './create-new-view-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    MatDialogModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatStepperModule,
    TranslateModule,
    CustomViewModalViewsModule,
    DialogCloseButtonComponent,
    ContentLoaderComponent
  ],
  providers: [CustomViewService],
  declarations: [CreateNewViewDialogComponent],
  exports: [CreateNewViewDialogComponent]
})
export class CreateNewViewDialogModule {}
